import React, { useEffect, useState } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';

import S from './Portfolio.module.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchGalleryListData, fetchGalleryDetailData } from '../../services/portfolioService';
import Pagination from '../../components/Paging/Pagination';
import { SERVER_URL } from '../../config';
import DetailModal from '../../components/Modal/DetailModal';
import { isMobile } from '../../config';

const DeliveryPage = () => {

  const { pageIdx } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [galleryData, setGalleryData] = useState([]);
  const [pagingInfo, setPagingInfo] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [dgDetailData, setDgDetailData] = useState();

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  const galleryListData = async (pageIdx) => {
    const response = await fetchGalleryListData(null, pageIdx);
    setGalleryData(response.dgList);
    setPagingInfo(response.pageInfo);
  }

  useEffect(() => {
    galleryListData(pageIdx);
  }, [location, pageIdx])

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/portfolio/delivery/${pageNumber}`)
  }

  const openDetailModal = async (idx) => {
    const galleryDetailData = await fetchGalleryDetailData(idx);
    setDgDetailData(galleryDetailData);
    setIsDetailModalOpen(true);
  }

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setDgDetailData(null);
  }

  return (
    <div>
      <HeaderComponents pageKey="portfolio" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="portfolio" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div id={S.lineDiv}></div>
            <div id={S.ptListWrap}>
              {galleryData && galleryData.map((item, index) => (
                <div onClick={() => openDetailModal(item.DG_IDX)}  key={index} className={S.ptDataDiv}>
                  <div className={`${S.ptListImgDiv} ${S.dvListImgDiv}`}>
                    <img src={SERVER_URL + item.DG_THUMBNAIL} alt='listImg' className={S.ptListImg}/>
                  </div>
                  <div className='mt-20'>{item.DG_TITLE}</div>
                </div>
              ))}
            </div>
            <Pagination 
              currentPage={pagingInfo.curPage}
              totalPages={pagingInfo.totalPage}
              onPageChangeHandler={onPageChangeHandler}
            />
            
            {isDetailModalOpen && (
              <DetailModal isOpen={isDetailModalOpen} onClose={closeDetailModal} data={dgDetailData} imgUrl={SERVER_URL}/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPage;
